<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-checkbox
	[checked]="checked"
	[disabled]="disabled"
	(change)="onChecked($event.checked)"
>
	<ng-content />
</mat-checkbox>
